import { createApp } from 'vue';
import AvifToPngConverter from '../Components/AvifToPngConverter.vue';

const root = document.getElementById('avif-to-png-converter');
if (root) {
  createApp(AvifToPngConverter).mount('#avif-to-png-converter');
}
